"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Dialog_1 = require("./Dialog");
exports.Dialog = Dialog_1.Dialog;
var DialogActionsBar_1 = require("./DialogActionsBar");
exports.DialogActionsBar = DialogActionsBar_1.DialogActionsBar;
var Window_1 = require("./Window");
exports.Window = Window_1.Window;
//# sourceMappingURL=main.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dialogs@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-dialogs/dist/npm/main.js
// module id = 120
// module chunks = 0